import { render, staticRenderFns } from "./CreateUserComponent.vue?vue&type=template&id=3129e595&"
import script from "./CreateUserComponent.vue?vue&type=script&lang=js&"
export * from "./CreateUserComponent.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserComponent.vue?vue&type=style&index=0&id=3129e595&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports